/**
 * Public Configuration Service
 *
 * Fetches public configuration (no authentication required).
 * Used for displaying pricing and limits on public pages.
 */

import api from './api';
import type { ApiResponse } from '@budgira/shared';

/**
 * Public configuration interface.
 */
export interface PublicConfig {
  freeAccount: {
    operationLimit: number;
    accountLimit: number;
  };
  subscription: {
    monthlyPrice: number;
    annualPrice: number;
    annualMonthlyEquivalent: number;
    annualSavingsPercent: number;
  };
  paypal: {
    clientId: string;
    planId: string;
  };
}

export const publicConfigService = {
  /**
   * Get the public configuration
   */
  async get(): Promise<ApiResponse<PublicConfig>> {
    const response = await api.get<ApiResponse<PublicConfig>>('/public/config');
    return response.data;
  },
};

export default publicConfigService;
